export default __webpack_public_path__ + "static/assets/78e052a258c29880bd1f6d4a3eb58449.svg";